/* Evan Red: details-film. Laadt pas vlak voor beeld (mobiel 720p, desktop 1080p), speelt alleen in beeld,
   onderschrift volgt de shot (data-a/data-b in seconden), voortgang = kleine golf die zich tekent (SVG-pad met pathLength 1).
   Desktop: het beeld staat vast (sticky, 90svh) en gaat open vanuit het midden langs de golf.
   Mobiel (1 nov 2026): vierkant beeld, bovengolf vast, ondergolf schuift van boven naar onderen; uitsnede blijft staan.
   2 nov 2026 (wens Remco): opening los van scrollsnelheid. Scrollen bepaalt alleen OF hij open of dicht moet;
     het openen zelf loopt altijd in hetzelfde tempo (1,6 s, rustige ease). Terug omhoog = in hetzelfde tempo dicht.
   Minder beweging of databesparing: alleen de poster met het eerste onderschrift, direct open.
   Vorige versie (scroll-gestuurd): assets/er-details.backup-20261102-scroll.js.txt */
(function () {
  var DUR_OPEN = 1600, DUR_GROW = 700;
  function init(root) {
    if (root.__erx) return; root.__erx = true;
    var video = root.querySelector('.erx-film__video');
    var caps = [].slice.call(root.querySelectorAll('[data-erx-cap]')).map(function (el) {
      return { el: el, a: parseFloat(el.getAttribute('data-a')) || 0, b: parseFloat(el.getAttribute('data-b')) || 0 };
    });
    var bar = root.querySelector('[data-erx-bar]');
    var barSvg = !!(bar && bar.namespaceURI === 'http://www.w3.org/2000/svg');
    var mq = window.matchMedia('(max-width: 749px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var save = !!(navigator.connection && navigator.connection.saveData);
    var off = [], ios = [], raf = 0, dead = false, inView = false, current = '', lastCap = -1;
    function on(el, ev, fn, o) { el.addEventListener(ev, fn, o); off.push(function () { el.removeEventListener(ev, fn, o); }); }

    function show(i) {
      if (i === lastCap) return; lastCap = i;
      caps.forEach(function (c, k) { c.el.classList.toggle('is-on', k === i); });
    }
    function progress(q) {
      if (!bar) return;
      if (barSvg) bar.style.strokeDashoffset = (1 - q).toFixed(4);
      else bar.style.transform = 'scaleX(' + q.toFixed(4) + ')';
    }
    if (reduce || save || !video) { root.classList.add('is-still'); show(0); progress(1); return; }

    var stage = root.querySelector('.erx-film__stage') || root, frameEl = root.querySelector('.erx-film__frame') || root, ticking = false;
    var wave = root.querySelector('.erx-film__wave'), wt = wave && wave.querySelector('.erx-film__wt'), wb = wave && wave.querySelector('.erx-film__wb');
    var POS = parseFloat(root.getAttribute('data-wave-pos')) || 0.62;
    /* middellijn van de golf, genormaliseerd: x 0..1 (links naar rechts), y 1 = laag (links), 0 = hoog (rechts) */
    var PTS = (function () {
      var S = [[0, 80, 20.78, 80, 42.61, 61.99, 64.79, 43.68], [64.79, 43.68, 90.16, 22.74, 117.73, 0, 147.79, 0]], out = [[0, 1]];
      S.forEach(function (c) {
        for (var i = 1; i <= 12; i++) {
          var t = i / 12, u = 1 - t, b0 = u * u * u, b1 = 3 * u * u * t, b2 = 3 * u * t * t, b3 = t * t * t;
          out.push([(b0 * c[0] + b1 * c[2] + b2 * c[4] + b3 * c[6]) / 147.79, (b0 * c[1] + b1 * c[3] + b2 * c[5] + b3 * c[7]) / 80]);
        }
      });
      return out;
    })();
    function c01(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
    function sm(x) { x = c01(x); return x * x * (3 - 2 * x); }
    function ease(x) { return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }

    /* Vast tempo: scroll zet alleen het doel (0 of 1), de waarde loopt er in vaste tijd naartoe. */
    var st = { grow: { v: 0, from: 0, to: 0, t0: 0, dur: DUR_GROW }, open: { v: 0, from: 0, to: 0, t0: 0, dur: DUR_OPEN } }, anim = 0;
    function aim(k, to) {
      var s = st[k];
      if (s.to === to) return;
      s.from = s.v; s.to = to; s.t0 = performance.now();
      s.dur = (k === 'open' ? DUR_OPEN : DUR_GROW) * Math.max(0.35, Math.abs(to - s.v));
      if (!anim) anim = requestAnimationFrame(tick);
    }
    function tick(now) {
      anim = 0;
      if (dead) return;
      var busy = false;
      ['grow', 'open'].forEach(function (k) {
        var s = st[k];
        if (s.v === s.to) return;
        var q = c01((now - s.t0) / s.dur);
        s.v = q >= 1 ? s.to : s.from + (s.to - s.from) * ease(q);
        if (q < 1) busy = true;
      });
      apply();
      if (busy) anim = requestAnimationFrame(tick);
    }
    function apply() {
      var mobile = mq.matches, open = st.open.v;
      root.style.setProperty('--grow', st.grow.v.toFixed(3));
      root.style.setProperty('--open', open.toFixed(3));
      /* desktop: lijnen vervagen als het beeld helemaal open is; mobiel: lijnen blijven staan */
      root.style.setProperty('--edge', mobile ? '1' : (1 - sm((open - 0.8) / 0.2)).toFixed(3));
      if (wave) shape(open, mobile);
    }
    function reveal() {
      ticking = false;
      if (dead) return;
      var vh = window.innerHeight, gT, oT;
      if (mq.matches) {
        var r = stage.getBoundingClientRect();
        var p = (vh * 0.95 - (r.top + r.height / 2)) / (vh * 0.45);
        gT = p > 0.02 ? 1 : 0;
        oT = p >= 0.4 ? 1 : (p < 0.15 ? 0 : st.open.to);
      } else {
        var R = root.getBoundingClientRect(), H = frameEl.offsetHeight || vh;
        var g = (vh * 0.95 - (R.top + H / 2)) / Math.max(1, vh * 0.95 - H / 2);
        gT = g > 0.05 ? 1 : 0;
        oT = R.top <= vh * 0.5 ? 1 : (R.top > vh * 0.75 ? 0 : st.open.to);
      }
      aim('grow', gT);
      aim('open', oT);
    }
    /* Vorm = middellijn uit Graphic_Element.eps (2016); trede-hoogte gelijk aan de golf elders: clamp(24px, 4vw, 64px).
       Desktop: boven- en ondergolf schuiven vanuit het midden uit elkaar; helemaal open = geen uitsnede.
       Mobiel: bovengolf vast bovenaan, ondergolf schuift van boven naar onderen; ook helemaal open blijft de uitsnede staan. */
    function shape(open, mobile) {
      var w = stage.clientWidth, h = stage.clientHeight;
      if (!w || !h) return;
      var H = Math.max(24, Math.min(64, window.innerWidth * 0.04)), W = H * 1.8474;
      var x0 = w * POS - W / 2, half = H / 2 + 1.5;
      function edge(y) {
        var a = [[0, y + H / 2], [x0, y + H / 2]];
        for (var k = 1; k < PTS.length; k++) a.push([x0 + PTS[k][0] * W, y + (PTS[k][1] - 0.5) * H]);
        a.push([w, y - H / 2]);
        return a;
      }
      var top, bot, full = false;
      if (mobile) {
        top = edge(half);
        bot = edge(half + open * (h - 2 * half));
      } else {
        var cy = h / 2, d = open * (h / 2 + H / 2 + 4);
        top = edge(cy - d); bot = edge(cy + d);
        full = open >= 0.999;
      }
      function str(a) { return a.map(function (p) { return p[0].toFixed(1) + ' ' + p[1].toFixed(1); }); }
      root.style.setProperty('--erx-clip', full ? 'none' :
        'polygon(' + str(top).concat(str(bot.slice().reverse())).map(function (q) { return q.replace(' ', 'px ') + 'px'; }).join(',') + ')');
      wave.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
      wt.setAttribute('d', 'M' + str(top).join('L'));
      wb.setAttribute('d', 'M' + str(bot).join('L'));
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(reveal); } }
    on(window, 'scroll', onScroll, { passive: true });
    on(window, 'resize', function () { apply(); onScroll(); });
    apply();
    reveal();

    function frame() {
      raf = 0;
      if (dead) return;
      var t = video.currentTime, d = video.duration || 0, i = -1;
      for (var k = 0; k < caps.length; k++) if (t >= caps[k].a && t < caps[k].b) { i = k; break; }
      show(i);
      if (d) progress(Math.min(1, t / d));
      if (!video.paused) raf = requestAnimationFrame(frame);
    }
    function play() { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
    function pick() {
      var src = mq.matches ? root.getAttribute('data-src-m') : root.getAttribute('data-src-d');
      if (!src || src === current) return;
      var t = video.currentTime || 0;
      current = src;
      root.classList.remove('is-playing');
      video.src = src; video.preload = 'auto'; video.load();
      if (t) try { video.currentTime = t; } catch (e) {}
      if (inView && !document.hidden) play();
    }

    video.muted = true;
    on(video, 'playing', function () { root.classList.add('is-playing'); if (!raf) raf = requestAnimationFrame(frame); });
    on(video, 'pause', frame);
    on(video, 'error', function () { root.classList.remove('is-playing'); });
    on(document, 'visibilitychange', function () { if (document.hidden) video.pause(); else if (inView && current) play(); });

    if ('IntersectionObserver' in window) {
      var near = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { pick(); near.disconnect(); } }, { rootMargin: '60% 0px' });
      var seen = new IntersectionObserver(function (es) {
        inView = es[0].isIntersecting;
        if (inView) { pick(); play(); } else video.pause();
      }, { threshold: 0.3 });
      near.observe(root); seen.observe(root.querySelector('.erx-film__stage') || root);
      ios.push(near, seen);
    } else { inView = true; pick(); }
    function onMq() { pick(); apply(); reveal(); }
    if (mq.addEventListener) { mq.addEventListener('change', onMq); off.push(function () { mq.removeEventListener('change', onMq); }); }
    else if (mq.addListener) { mq.addListener(onMq); off.push(function () { mq.removeListener(onMq); }); }

    root.__erxDestroy = function () {
      dead = true;
      if (raf) cancelAnimationFrame(raf);
      if (anim) cancelAnimationFrame(anim);
      ios.forEach(function (o) { o.disconnect(); });
      off.forEach(function (f) { f(); });
      video.pause();
      root.__erx = false;
    };
  }
  function boot(e) {
    var scope = e && e.target && e.target.querySelectorAll ? e.target : document;
    scope.querySelectorAll('[data-erx-film]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  if (!window.__erxBoot) {
    window.__erxBoot = true;
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:section:unload', function (e) {
      if (!e.target || !e.target.querySelectorAll) return;
      e.target.querySelectorAll('[data-erx-film]').forEach(function (r) { if (r.__erxDestroy) r.__erxDestroy(); });
    });
  }
})();